import { BaseDto } from './base.dto';
import {
  MailDirection,
  OutlookCategoryKind,
  RoutingExampleSource,
  RoutingRuleAction,
  RoutingRuleMatch,
  RoutingTargetKind,
  TriageCategory,
  TriageEventStatus,
  TriageEvidence,
  TriageOutcome,
  WatchedMailboxKind
} from './mail-triage.dto';
import { TriageMode } from './ai-settings.dto';

/** Frontend DTOs mirroring the mail-intelligence entities. */

export class WatchedMailbox extends BaseDto {
  address?: string;
  kind?: WatchedMailboxKind;
  userId?: number | null;
  mode?: TriageMode;
  enabled?: boolean;
  subscriptionId?: string | null;
  subscriptionExpiresAt?: Date | string | null;
  deltaLink?: string | null;
  lastSyncAt?: Date | string | null;
  lastNotificationAt?: Date | string | null;
  historyImportedAt?: Date | string | null;
}

/** A department of the office mailbox (see RoutingTarget entity). */
export class RoutingTarget extends BaseDto {
  key?: string;
  name?: string;
  kind?: RoutingTargetKind;
  description?: string | null;
  inspectionTypeIds?: number[];
  keywords?: string[];
  outlookCategory?: string | null;
  folderName?: string | null;
  memberUserIds?: number[];
  enabled?: boolean;
  sortOrder?: number;
}

/** An Outlook category LCL sets (see the OutlookCategory entity). */
export class OutlookCategory extends BaseDto {
  name?: string;
  kind?: OutlookCategoryKind;
  targetId?: number | null;
  tag?: string | null;
  enabled?: boolean;
  sortOrder?: number;
}

export class RoutingRule extends BaseDto {
  name?: string;
  priority?: number;
  enabled?: boolean;
  match?: RoutingRuleMatch;
  action?: RoutingRuleAction;
  recipientUserIds?: number[];
  /** Department a `route` rule sends mail to. */
  targetId?: number | null;
  isOverride?: boolean;
  notes?: string | null;
}

export class MailMessageSummary extends BaseDto {
  mailboxAddress?: string;
  direction?: MailDirection;
  fromAddress?: string;
  fromName?: string;
  fromDomain?: string;
  subject?: string;
  receivedAt?: Date | string;
  hasAttachments?: boolean;
  attachmentNames?: string[];
  suspectedInjection?: boolean;
  webLink?: string;
  conversationId?: string;
}

export class MailTriageEvent extends BaseDto {
  messageId?: number;
  message?: MailMessageSummary;
  mailboxAddress?: string;
  mode?: TriageMode;
  status?: TriageEventStatus;
  category?: TriageCategory;
  suggestedUserIds?: number[];
  suggestedAddresses?: string[];
  /** Department the engine chose (route decisions). */
  targetId?: number | null;
  /** Topic tags from the settings vocabulary, e.g. חשבונית, תעודה. */
  tags?: string[];
  evidence?: TriageEvidence | null;
  confidence?: number | string | null;
  reasoning?: string | null;
  noteHe?: string | null;
  retrievedExampleIds?: number[];
  ruleId?: number | null;
  suspectedInjection?: boolean;
  provider?: string | null;
  model?: string | null;
  promptTokens?: number;
  completionTokens?: number;
  costUSD?: number | string;
  latencyMs?: number | null;
  draftGraphMessageId?: string | null;
  draftCreatedAt?: Date | string | null;
  outcome?: TriageOutcome;
  actualUserIds?: number[] | null;
  actualAddresses?: string[] | null;
  /** Department the office chose (correction, or a forward to a member). */
  actualTargetId?: number | null;
  outcomeAt?: Date | string | null;
  outcomeBy?: string | null;
  error?: string | null;
}

export interface RetrievedExampleView {
  id: number;
  source: RoutingExampleSource;
  weight: number;
  recipientUserIds: number[];
  recipientAddresses: string[];
  targetId?: number | null;
  excerpt: string;
  subject?: string;
  fromAddress?: string;
  receivedAt?: Date | string;
}
